import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { GlobalStyle } from "../TabNavigation/styles/router-nav-styles";
import JobProfileView from "./JobProfileView";
import jobProfileType from "./types/jobProfileType";
import jobStatusWidgetType from "./types/jobStatusWidgetType";

class JobProfile extends Component {
  constructor(props) {
    super(props);

    const { jobProfile } = this.props;

    const {
      id,
      agencyBriefing,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencyOptions,
      currencySymbol,
      currencyIsoCode,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      postcode,
      notificationRecipientIds,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      exclusive,
      finalSalary,
      positionFilled,
      audienceMemberIds,
      burst,
      publishedStatus,
      numberOfPositions,
    } = jobProfile;

    this.state = {
      id,
      agencyBriefing,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencyOptions,
      currencySymbol,
      currencyIsoCode,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      editModalActive: false,
      errors: {},
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      loading: false,
      location,
      postcode,
      notificationRecipientIds,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      step: null,
      vacancyReason,
      visaSponsorship,
      exclusive,
      finalSalary,
      positionFilled,
      audienceMemberIds,
      burst,
      publishedStatus,
      numberOfPositions,
    };
  }

  componentDidMount() {
    document.body.classList.add("job-profile-tab");
  }

  componentDidUpdate(prevProps, prevState) {
    const { getActionBarData } = this.props;
    const { jobTitle, location, salaryRange } = this.state;

    if (this.state !== prevState) {
      const data = {
        title: jobTitle,
        subtitle: `${location}, ${salaryRange}`,
      };

      getActionBarData(data);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("job-profile-tab");
  }

  handleModalShow = (e) => {
    e.preventDefault();
    const { editModalActive } = this.state;
    this.setState({ editModalActive: !editModalActive, step: 1 });
    document.body.classList.toggle("modalOverlay");
  };

  handleNext = () => {
    this.setState(({ step }) => ({ step: step + 1 }));
  };

  handlePrev = () => {
    this.setState(({ step }) => ({ step: step - 1 }));
  };

  validate = (formData) => {
    const { jobProfile, isPortalEmployer } = this.props;
    const { validateUrl, jobId } = jobProfile;

    const numberOfPositionsAttributes = formData.numberOfPositions;
    const audienceAttributes = isPortalEmployer
      ? { id: formData.audienceId, recruiter_ids: formData.audienceMemberIds }
      : undefined;
    const burstOntoTheMarketplace = isPortalEmployer
      ? formData.burst
      : undefined;

    const requestData = {
      job: {
        id: jobId,
        agency_briefing: formData.agencyBriefing,
        title: formData.jobTitle,
        job_type: formData.jobType,
        location: formData.location,
        key_skills: formData.keySkills,
        description: formData.description,
        benefit_ids: formData.benefitIds,
        degree_required: formData.degreeRequired,
        visa_sponsorship: formData.visaSponsorship,
        consider_relocation: formData.considerRelocation,
        vacancy_reason: formData.vacancyReason,
        feedback_timescale_id: formData.feedbackTimescaleId,
        interview_comments: formData.interviewComments,
        interview_stages: formData.interviewStages,
        salary_min: formData.salaryMin,
        salary_max: formData.salaryMax,
        salary_range: formData.salaryRange,
        salary_type: formData.salaryType,
        placement_fee_percent: formData.recruiterFeePercentage,
        contract_duration: formData.contractDuration,
        contract_duration_interval: formData.contractDurationInterval,
        sector_id: formData.sectorId,
        cv_limit_per_recruiter: formData.cvLimitPerRecruiter,
        notification_recipient_ids: formData.notificationRecipientIds,
        audience_attributes: audienceAttributes,
        burst_onto_the_marketplace: burstOntoTheMarketplace,
        number_of_positions: numberOfPositionsAttributes,
        currency_id: formData.currencyId,
      },
    };

    const payload = {
      url: validateUrl,
      method: "post",
      data: requestData,
    };

    return axios(payload)
      .then(() => true)
      .catch(({ response }) => {
        this.setState({
          loading: false,
          errors: response.data.errors,
        });
        return false;
      });
  };

  updateJobProfile = (formData) => {
    const { jobProfile, isPortalEmployer, updateAgentsTabContent } = this.props;
    const { url } = jobProfile;
    const numberOfPositionsAttributes = formData.numberOfPositions;
    const audienceAttributes = isPortalEmployer
      ? { id: formData.audienceId, recruiter_ids: formData.audienceMemberIds }
      : undefined;
    const burstOntoTheMarketplace = isPortalEmployer
      ? formData.burst
      : undefined;

    this.setState({ loading: true });

    const requestData = {
      job: {
        agency_briefing: formData.agencyBriefing,
        title: formData.jobTitle,
        job_type: formData.jobType,
        location: formData.location,
        postcode: formData.postcode,
        key_skills: formData.keySkills,
        description: formData.description,
        benefit_ids: formData.benefitIds,
        degree_required: formData.degreeRequired,
        visa_sponsorship: formData.visaSponsorship,
        consider_relocation: formData.considerRelocation,
        vacancy_reason: formData.vacancyReason,
        feedback_timescale_id: formData.feedbackTimescaleId,
        interview_comments: formData.interviewComments,
        interview_stages: formData.interviewStages,
        salary_min: formData.salaryMin,
        salary_max: formData.salaryMax,
        salary_range: formData.salaryRange,
        salary_type: formData.salaryType,
        placement_fee_percent: formData.recruiterFeePercentage,
        contract_duration: formData.contractDuration,
        contract_duration_interval: formData.contractDurationInterval,
        sector_id: formData.sectorId,
        cv_limit_per_recruiter: formData.cvLimitPerRecruiter,
        notification_recipient_ids: formData.notificationRecipientIds,
        audience_attributes: audienceAttributes,
        burst_onto_the_marketplace: burstOntoTheMarketplace,
        number_of_positions: numberOfPositionsAttributes,
        currency_id: formData.currencyId,
      },
    };

    /* if the job is already burst, we remove burst_onto_the_marketplace from the
       params to update. Passing burst_onto_the_marketplace will update the
       burst_onto_the_marketplace_at value resulting in emails going out to
       recruiters which is undesired behaviour for already burst jobs.
     */
    if (jobProfile.burst === true) {
      delete requestData.job.burst_onto_the_marketplace;
    }

    const payload = {
      url,
      method: "patch",
      data: requestData,
    };

    axios(payload)
      .then(({ data }) => {
        this.setState({
          data,
          errors: {},
          loading: false,
          editModalActive: false,
        });
        document.body.classList.remove("modalOverlay");

        updateAgentsTabContent(data.agents);
      })
      .catch(({ response }) => {
        this.setState({
          errors: response.data.errors,
          loading: false,
        });
      });
  };

  render() {
    const { isRecruiter, jobProfile, jobStatusWidget } = this.props;

    const {
      accountManager,
      accountManagerAvatar,
      applicationsAtOfferOrAccepted,
      audienceId,
      audienceMembers,
      benefitOptions,
      closeJobUrl,
      copyJobUrl,
      dateCreated,
      employerAccountType,
      engagementId,
      finalSalary,
      isJobActive,
      jobStatus,
      messageEmployerUrl,
      notificationRecipients,
      publishedStatus,
      positionFilled,
      sectorOptions,
      vacancyReasonOptions,
      currencyOptions,
      currencyId,
    } = jobProfile;

    const newProps = {
      accountManager,
      accountManagerAvatar,
      applicationsAtOfferOrAccepted,
      audienceId,
      audienceMembers,
      benefitOptions,
      closeJobUrl,
      copyJobUrl,
      currencyId,
      currencyOptions,
      employerAccountType,
      messageEmployerUrl,
      engagementId,
      dateCreated,
      isJobActive,
      isRecruiter,
      jobStatus,
      jobStatusWidget,
      notificationRecipients,
      publishedStatus,
      sectorOptions,
      vacancyReasonOptions,
      finalSalary,
      positionFilled,
      handleModalShow: this.handleModalShow,
      handlePrev: this.handlePrev,
      handleNext: this.handleNext,
      validate: this.validate,
      updateJobProfile: this.updateJobProfile,
    };

    return (
      <Fragment>
        <GlobalStyle />
        <JobProfileView
          {...this.props}
          {...this.state}
          {...newProps}
          jobProfile={jobProfile}
        />
      </Fragment>
    );
  }
}

JobProfile.propTypes = {
  updateAgentsTabContent: PropTypes.func,
  jobProfile: jobProfileType.isRequired,
  jobStatusWidget: jobStatusWidgetType.isRequired,
  getActionBarData: PropTypes.func.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  isPortalEmployer: PropTypes.bool,
};

JobProfile.defaultProps = {
  updateAgentsTabContent: null,
  isPortalEmployer: null,
};

JobProfile.defaultProps = {
  updateAgentsTabContent: null,
  isPortalEmployer: null,
};

export default JobProfile;
